export const darkKnight = "DARK_KNIGHT";

export const iceElves = "CREYATES_ICE_ELVES";

export const illustrationsByAuthor = {
  crom: [
    darkKnight,
    "DWARF_ARCHER",
    "BEAST",
    "FAMILIAR",
    "GOBLINS",
    "ICE_ZOMBIES",
    "OORM",
    "WOUNDED_ELF",
    "ELF_ARCHER",
    "ELF_WARRIOR",
    "HUNTER",
    "WIZARD",
  ],
  creyates: [iceElves, "CREYATES_ORC_LEGIONARY", "CREYATES_TROLL_HOWDAH"],
  sean: [
    "CURSADERS",
    "DROGONOID_BARBARIAN",
    "DWARF_SPEARMAN",
    "EASTERN_HOBGOBLIN",
    "HILLTOP_MANOR",
    "PALADIN",
    "SEA_EMPIRE_SOLDIER",
  ],
};

export const thumbSize = {
  width: 350,
  height: 350,
};
